import { ratingBars, reviews } from "@/mocks/content";

export default function ReviewSection() {
  return (
    <section id="reviews" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl" data-reveal>
            <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
              观众口碑：大家在意哪些部分
            </h2>
            <p className="mt-3 text-foreground-600 leading-8">
              把观众反馈归类后可以看到，大家最在意的并不是反转有多快，而是情感是否真实、人物是否立得住。
              以下维度与短评均为编辑整理的示意内容。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-10 lg:gap-14 items-start">
          <div className="p-6 rounded-xl bg-background-100 border border-background-200" data-reveal>
            <h3 className="font-heading font-semibold text-foreground-950 text-lg">反馈维度</h3>
            <div className="mt-5 space-y-5">
              {ratingBars.map((r) => (
                <div key={r.label}>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-foreground-700">{r.label}</span>
                    <span className="text-foreground-500">{r.value}</span>
                  </div>
                  <div className="mt-2 h-2 w-full rounded-full bg-background-300/60 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${r.value}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-6 text-xs text-foreground-500 leading-6">
              数值为编辑整理的示意评分，用于说明观众关注的重点，不代表平台官方评分。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {reviews.map((r) => (
              <div
                key={r.name}
                data-reveal
                className="p-5 rounded-xl bg-background-100 border border-background-200 flex flex-col"
              >
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-900 font-heading text-sm">
                    {r.name.slice(-1)}
                  </span>
                  <div>
                    <p className="text-sm text-foreground-900">{r.name}</p>
                    <div className="flex items-center gap-1 text-accent-600 text-xs">
                      <i className="ri-star-fill" aria-hidden="true"></i>
                      {r.score}
                    </div>
                  </div>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-7 flex-1">{r.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}